<template>
	<div class="list">
		<div class="list-tt">命局四象</div>
		<div class="list-info">
			<div v-if="infoHtml">
				<div class="xingge">
					<h4>性格</h4>
					<p>{{infoHtml.性格}}</p>
				</div>
				<div class="shiye">
					<h4>事业</h4>
					<p>{{infoHtml.事业}}</p>
				</div>
				<div class="caiyun">
					<h4>财运</h4>
					<p>{{infoHtml.财运}}</p>
				</div>
				<div class="hunyin">
					<h4>婚姻</h4>
					<p>{{infoHtml.婚姻}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['sixiang'],
		data() {
			return {
				infoHtml: '',
				sex: {
					1: '男',
					2: '女'
				},
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				shenSingleDict: { //十神单神断语
					比肩: {
						wang: {
							性格: "性直气刚，自尊好强，重义轻财，固执不挠，不喜受制。",
							事业: "自立自强，宜独资、自营、自由业；合伙易争权，受制则不服。",
							财运: "能挣难聚，财来财去，易被亲友分财、借贷拖累。",
							婚姻: "性刚难屈，争执多，晚婚偏稳。"
						},
						ruo: {
							性格: "孤寡少援，主见不足，遇事依赖，人缘平淡。",
							事业: "单打独斗，少同辈助力，宜安稳随众，难独当一面。",
							财运: "无争财之心，收入平稳，难有意外之财。",
							婚姻: "情淡被动，不懂经营，缘分偏迟。"
						},
						over: {
							特殊: "比劫林立，身无依倚，骨肉情疏，破财官非，克父克妻。"
						}
					},
					劫财: {
						wang: {
							性格: "性急豪爽，野心大，好胜心强，重情好义，冲动易怒。",
							事业: "敢闯敢拼，宜开拓、销售、创业；竞争中得机，亦招小人。",
							财运: "大手大脚，易合伙破财、人情耗财、投机失利。",
							婚姻: "占有欲强，言语刚直，口舌争执多，晚婚为宜。"
						},
						ruo: {
							性格: "低调不争，安分守己，少进取心。",
							事业: "缺乏冲劲，安于现状，适合稳定岗位。",
							财运: "守财尚可，无横财，平平淡淡。",
							婚姻: "温和包容，感情少波澜。"
						},
						两头挂: {
							特殊: "劫财两头挂，一生多波折，亲情淡薄，财来财去。"
						}
					},
					食神: {
						wang: {
							性格: "温和宽厚，乐观豁达，聪明秀气，知足常乐，口福佳。",
							事业: "有才艺、口才、手艺天赋，宜技术、文创、餐饮、教育。",
							财运: "秀气生财，正财绵长，越老越稳，衣食无忧。",
							婚姻: "体贴顾家，包容温和，子女缘厚，婚姻安稳。"
						},
						ruo: {
							性格: "寡情少趣，不善表达，思想偏呆板。",
							事业: "无特长才艺，适合普通岗位，难靠技艺出头。",
							财运: "财源单薄，缺生财门路，仅固定收入。",
							婚姻: "不懂浪漫，感情平淡务实。"
						},
						空亡无根: {
							特殊: "食神空亡，口福不足，福气减半，子女缘薄。"
						}
					},
					伤官: {
						wang: {
							性格: "聪慧绝顶，思路多变，傲气凌人，叛逆不服管，口才犀利。",
							事业: "宜创意、设计、电商、自媒体、自由业；忌体制约束。",
							财运: "商机敏锐，靠才智、副业、投资得财，起伏大、来财快。",
							婚姻: "眼高挑剔，性倔言刚，易伤配偶，晚婚更稳。"
						},
						ruo: {
							性格: "思想保守，创意不足，不爱表现。",
							事业: "循规蹈矩，难有破格发展。",
							财运: "无投机机缘，安稳死工资。",
							婚姻: "随缘本分，无多波折。"
						}
					},
					正财: {
						wang: {
							性格: "务实勤俭，稳重踏实，重信讲义，重视现实利益。",
							事业: "宜实业、稳定上班、管理岗；一步一个脚印，稳步上升。",
							财运: "正财稳健，善于守财，理财保守，家底渐厚。",
							婚姻: "顾家负责，专一踏实。"
						},
						ruo: {
							性格: "财念淡薄，不计得失，随性散漫。",
							事业: "收入普通，无稳定上升渠道。",
							财运: "正财薄弱，存钱难，开销多、留不住积蓄。",
							婚姻: "物质条件一般，平淡度日。"
						}
					},
					偏财: {
						wang: {
							性格: "慷慨大方，人缘广，讲义气，有商业头脑，看淡小钱。",
							事业: "宜贸易、投资、中介、副业、经商；易得贵人机缘、意外之财。",
							财运: "偏财旺有横财、副业财、贵人送财，来财渠道多。",
							婚姻: "异性缘旺，防烂桃花。"
						},
						ruo: {
							性格: "不喜应酬，人脉普通，无冒险心。",
							事业: "无副业机缘，主业谋生。",
							财运: "无横财，老老实实挣辛苦钱。",
							婚姻: "异性缘平淡，感情专一简单。"
						}
					},
					正官: {
						wang: {
							性格: "正直守礼，稳重自律，有责任心，顾及名声，谦和有度。",
							事业: "宜公职、体制、管理、行政；易得贵人提携，仕途平稳有升。",
							财运: "事业带动财运，正路求财，名利双收，不走偏门。",
							婚姻: "顾家负责，婚姻正统稳定。"
						},
						ruo: {
							性格: "自律不足，散漫随性，缺原则约束。",
							事业: "无官运贵气，难进体制做管理，适合普通岗位。",
							财运: "靠劳力技术谋生，无官职附带之财。",
							婚姻: "缘分普通，缺正统安稳姻缘。"
						}
					},
					七杀: {
						wang: {
							性格: "刚毅果决，有魄力威严，性子急，抗压极强，多疑警觉。",
							事业: "宜军警、司法、管理、创业、高压行业；能扛事掌权，磨难中成器。",
							财运: "竞争中得财，打拼得富贵，中年后稳步走高。",
							婚姻: "个性强势，配偶亦倔，磨合多。"
						},
						ruo: {
							性格: "胆子偏小，顾虑多，缺魄力闯劲。",
							事业: "不敢竞争，安于现状，难担大任。",
							财运: "无冒险求财机缘，平稳即可。",
							婚姻: "温和迁就，感情少风波。"
						}
					},
					正印: {
						wang: {
							性格: "仁慈宽厚，稳重厚道，爱思考，有修养，依赖心稍强。",
							事业: "宜文教、文化、玄学、公职、后勤；多得长辈贵人帮扶，安稳少波折。",
							财运: "福气生财，不靠打拼靠机缘贵人，财运安稳。",
							婚姻: "温顺包容，顾家体贴，多得长辈认可姻缘。"
						},
						ruo: {
							性格: "包容不足，想法现实，福气偏弱。",
							事业: "贵人助力少，靠自己打拼。",
							财运: "无暗福机缘，全凭劳力挣钱。",
							婚姻: "长辈助力少，姻缘靠自己争取。"
						},
						over: {
							特殊: "印旺身弱，懒惰依赖，优柔寡断，一事无成。"
						}
					},
					偏印: {
						wang: {
							性格: "悟性极高，敏感多疑，思想独特，喜静内向，偏玄学宗教。",
							事业: "宜玄学、命理、艺术、策划、科研、小众专业；偏门技艺立身。",
							财运: "偏门生财、技艺生财，冷门行业易得利。",
							婚姻: "孤僻爱独处，心思重，精神内耗，晚婚居多。"
						},
						ruo: {
							性格: "想法普通，无特殊悟性，随大流度日。",
							事业: "无偏门机缘，走大众普通路子。",
							财运: "无冷门副业财源，安分守己。",
							婚姻: "心态随和，感情简单平淡。"
						}
					}
				},
				comboDict: { //组合格局断语
					// 吉格
					官印相生: {
						性格: "正直稳重，谦和有修养，处事规矩靠谱，心性仁厚大度。",
						事业: "贵人运强，公职体制、文教管理，长辈领导扶持，仕途平稳晋升。",
						财运: "正福稳财，名利相随，不靠冒险，靠地位人脉稳步聚财。",
						婚姻: "姻缘端正稳重，对象品行端正，家庭和睦，长辈祝福。"
					},
					杀印相生: {
						性格: "外刚内柔，有魄力担当，抗压极强，遇事沉稳能扛事。",
						事业: "化压力为权势，军警司法、企业管理、创业带队，磨难中成大器。",
						财运: "打拼得财，越闯越有，中年后财运稳步走高。",
						婚姻: "有责任感顾家，性格偏刚但懂包容担当。"
					},
					食神生财: {
						性格: "温和乐观，聪明随和，心态知足，待人厚道。",
						事业: "靠手艺、口才、专业、文创、餐饮立身，技艺越精财运越旺。",
						财运: "秀气生财，正财绵长，稳健聚财，越老越富足。",
						婚姻: "体贴顾家，懂得包容经营，婚姻安稳有福。"
					},
					财官双美: {
						性格: "务实稳重，精明强干，重信誉，有责任感。",
						事业: "富贵双全，事业财富双丰收，宜商业、管理、公职。",
						财运: "财源广进，名利兼收，正财偏财皆旺。",
						婚姻: "男命娶贤妻，女命嫁贵夫，婚姻美满。"
					},
					伤官配印: {
						性格: "聪慧多才，才华内敛，有主见，懂分寸，刚柔并济。",
						事业: "才华与学识兼备，文艺、科研、公职显贵，创意落地有成。",
						财运: "靠才华学识生财，稳定且有溢价，名利双收。",
						婚姻: "知性通透，懂包容，婚姻质量高。"
					},

					// 凶格
					伤官见官: {
						性格: "高傲直率，嘴快心软，不喜约束，易顶撞上级长辈。",
						事业: "不宜体制官场，易职场口舌是非、岗位变动、名誉受损。",
						财运: "财运起伏大，不宜公职求财，靠专业技艺反而安稳。",
						婚姻: "言语易伤人，个性倔强不服输，感情多争执磨合。"
					},
					比劫夺财: {
						性格: "仗义重情，好面子，心软乐于助人，但易人情吃亏。",
						事业: "适合独自发展，不宜盲目合伙，防朋友拖累事业。",
						财运: "能赚钱但难守财，易被熟人借钱、合伙破财、人情耗财。",
						婚姻: "重情义，但感情里易逞强争执，谦让则稳。"
					},
					枭神夺食: {
						性格: "心思细腻敏感，多虑多疑，内向孤僻，爱胡思乱想。",
						事业: "适合偏门、玄学、技艺、小众行业，不宜繁杂人际职场。",
						财运: "福气稍弱，口福一般，求财宜保守安稳，忌投机冒险。",
						婚姻: "内心孤独想得多，易精神内耗，晚婚更安稳。"
					},
					官杀混杂: {
						性格: "心思不定，矛盾纠结，易受外界影响，缺乏主见。",
						事业: "事业多变，职场小人多，压力大，难有稳定发展。",
						财运: "财运不稳，易因官非破财，投资失利。",
						婚姻: "男命感情混乱，女命夫星不明，婚姻多波折。"
					},
					财星坏印: {
						性格: "现实功利，重利轻义，易因财失德。",
						事业: "学业受损，贵人无力，因财招灾，丢官失名。",
						财运: "贪财反破财，投资失利，因财惹祸。",
						婚姻: "因财影响感情，婚姻易生裂痕。"
					},
					//自己新增
					伤官生财: {
						性格: "聪明机灵点子多，敢闯敢拼善于捕捉商机。",
						事业: "适合创业、销售、电商、投资，不喜被管束，适合自主经营。",
						财运: "来财快，门路多，靠才智致富。",
						婚姻: "有主见，感情直接，宜晚婚。"
					},
					食神制杀: {
						性格: "智勇双全深谙谋略，能以智慧驾驭压力与小人。",
						事业: "可掌大权做高管，属于典型大器晚成格局。",
						财运: "中年后得财，掌权生财。",
						婚姻: "有担当，家庭稳定。"
					},
					比劫助身: {
						性格: "人缘好朋友多，遇事易得同辈帮扶。",
						事业: "合伙做事有助力，抗压能力强，不会孤立无援。",
						财运: "朋友带财，共同发展。",
						婚姻: "朋友缘好，感情有人帮忙撮合。"
					},
					印比相生: {
						性格: "贵人有力生扶自身，长辈助力多、根基稳。",
						事业: "学业容易有成，多得身边人关照。",
						财运: "贵人送财，安稳少波折。",
						婚姻: "长辈介绍良缘，婚姻稳定。"
					},

					财多身弱: {
						性格: "机会多但定力不足，容易焦虑。",
						事业: "只宜安稳打工，不宜创业。",
						财运: "有财难留，容易借贷破财、投资踩坑。",
						婚姻: "因财压力大，影响感情稳定。"
					},

					身弱杀旺: {
						性格: "多虑焦虑，精神容易内耗，心态压抑。",
						事业: "压力大，小人多，波折多。",
						财运: "求财辛苦，劳累奔波。",
						婚姻: "感情压力大，易遇强势对象。"
					},

					印多身旺: {
						性格: "依赖性强、懒散拖延，想得多做得少。",
						事业: "缺乏上进心，容易原地踏步。",
						财运: "财运平稳但不主动，难发大财。",
						婚姻: "依赖心重，不够独立。"
					},
					食伤泄身太过: {
						性格: "心思过重、幻想太多，身心容易疲惫。",
						事业: "想法多行动少，容易脱离现实。",
						财运: "消耗大，聚财困难。",
						婚姻: "思虑多，容易敏感不安。"
					},
					比劫林立: {
						性格: "争强好胜、固执不服输。",
						事业: "人际关系易有竞争矛盾，合伙易纠纷。",
						财运: "求财多争夺，财来财去。",
						婚姻: "争执多，宜谦让。"
					}

				},
				specialGridDict: { //特殊格局断语
					伤官伤尽: "伤官伤尽反为奇，才华盖世，富贵可期，女命主贵。",
					从财格: "从财者富，依人成事，财运亨通，难自立。",
					从杀格: "从杀者贵，掌生杀大权，武职显贵，磨难中成器。",
					身弱不胜财官: "身弱财官旺，富屋贫人，压力重重，劳心劳力。"
				},
				wang: ['', '身弱', '中和', '身旺'],
				rules: { //核心规则
					wangThreshold: 2,
					overThreshold: 3,
					男: {
						wife: "财",
						career: "官杀"
					},
					女: {
						husband: "官杀",
						children: "食神"
					}
				}
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				let type = this.sixiang.type;
				let sex = this.sixiang.sex;
				let year = this.sixiang.year;
				let month = this.sixiang.month;
				let day = this.sixiang.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.sixiang.time];
				let timeName = this.times[this.sixiang.time];
				let shenLv = this.$store.state.shenLv;

				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}
				let tianShen = [bazi.getYearShiShenGan(), bazi.getMonthShiShenGan(), bazi.getTimeShiShenGan()];
				let diShen = [...bazi.getYearShiShenZhi(), ...bazi.getMonthShiShenZhi(), ...bazi.getDayShiShenZhi(), ...bazi.getTimeShiShenZhi()];
				let allShen = [...tianShen, ...diShen];
				let wangLevel = this.wang[shenLv];
				let shenCount = {
					比肩: 0,
					劫财: 0,
					食神: 0,
					伤官: 0,
					正财: 0,
					偏财: 0,
					正官: 0,
					七杀: 0,
					正印: 0,
					偏印: 0
				};

				allShen.forEach(item => {
					if (shenCount.hasOwnProperty(item)) {
						shenCount[item]++
					}
				})
				let gender = this.sex[sex];
				let hasGen = this.$store.state.hasGen; //身弱无根专用
				this.infoHtml = this.getFortune(shenCount, gender, wangLevel, hasGen);
				//console.log(this.infoHtml)
			},
			getFortune(shenCount, gender, wangLevel, hasGen) {
				let res = {
					特殊格局: [],
					组合格局: [],
					性格: [],
					事业: [],
					财运: [],
					婚姻: [],
					特殊提示: []
				};

				const {
					比肩,
					劫财,
					食神,
					伤官,
					正财,
					偏财,
					正官,
					七杀,
					正印,
					偏印
				} = shenCount;

				// ========== 1. 判特殊格局（优先级最高）==========
				// 伤官伤尽
				if (伤官 >= 2 && 正官 === 0 && 七杀 === 0) {
					res.特殊格局.push(this.specialGridDict.伤官伤尽);
				}
				// 从格条件：身弱 + 无根 才论从
				if (wangLevel === "身弱" && !hasGen) {
					// 从财格
					if ((正财 + 偏财) >= 3) {
						res.特殊格局.push(this.specialGridDict.从财格);
					}
					// 从杀格
					if ((正官 + 七杀) >= 3 && (正印 + 偏印) === 0) {
						res.特殊格局.push(this.specialGridDict.从杀格);
					}
				}
				// 身弱不胜财官
				if (wangLevel === "身弱" && (正财 + 偏财 + 正官 + 七杀) >= 4) {
					res.特殊格局.push(this.specialGridDict.身弱不胜财官);
				}

				// ========== 2. 判十神组合格局 ==========
				const addCombo = (name, cond) => {
					if (!cond) return;
					const d = this.comboDict[name];
					res.组合格局.push(name);
					res.性格.push(d.性格);
					res.事业.push(d.事业);
					res.财运.push(d.财运);
					res.婚姻.push(d.婚姻);
				};

				addCombo("官印相生", ((正官 && 正印) || (正官 && 偏印)));
				addCombo("杀印相生", ((七杀 && 正印) || (七杀 && 偏印)));
				addCombo("食神生财", ((食神 && 正财) || (食神 && 偏财)));
				addCombo("财官双美", ((正财 || 偏财) && (正官 || 七杀)) && wangLevel === "身旺");
				addCombo("伤官配印", (伤官 && 正印) && wangLevel === "身旺");
				addCombo("伤官生财", ((伤官 && 正财) || (伤官 && 偏财)) && wangLevel === "身旺");
				addCombo("食神制杀", (食神 && 七杀) && wangLevel === "身旺");
				addCombo("比劫助身", (比肩 && 劫财) && wangLevel === "身弱");
				addCombo("印比相生", ((正印 && 比肩) || (偏印 && 劫财)) && wangLevel === "身弱"); 
				
				addCombo("伤官见官", (伤官 && 正官) && !(正财 || 偏财));
				addCombo("比劫夺财", ((比肩 || 劫财) && (正财 || 偏财)) && wangLevel === "身旺");
				addCombo("枭神夺食", (偏印 && 食神) && !(比肩 || 劫财));
				addCombo("官杀混杂", (正官 && 七杀));
				addCombo("财星坏印", ((正财 || 偏财) && (正印 || 偏印)) && wangLevel === "身弱");
				
				addCombo("财多身弱", wangLevel === "身弱" && (正财 + 偏财) >= 2);
				addCombo("身弱杀旺", wangLevel === "身弱" && 七杀 >= 2 && !(正印 || 偏印 || 食神));
				addCombo("印多身旺", wangLevel === "身旺" && (正印 + 偏印) >= 2);
				addCombo("食伤泄身太过", wangLevel === "身弱" && (食神 + 伤官) >= 3);
				addCombo("比劫林立", wangLevel === "身旺" && (比肩 + 劫财) >= 3);
				
				// ========== 3. 单十神旺弱断语 ==========
				const isWang = n => n >= this.rules.wangThreshold;
				const isOver = n => n >= this.rules.overThreshold;

				for (const shen of Object.keys(this.shenSingleDict)) {
					const num = shenCount[shen];
					if (num <= 0) continue;
					const dict = this.shenSingleDict[shen];

					if (isOver(num) && dict.over) {
						res.特殊提示.push(dict.over.特殊);
					}
					if (isWang(num)) {
						res.性格.push(dict.wang.性格);
						res.事业.push(dict.wang.事业);
						res.财运.push(dict.wang.财运);
						res.婚姻.push(dict.wang.婚姻);
					} else {
						res.性格.push(dict.ruo.性格);
						res.事业.push(dict.ruo.事业);
						res.财运.push(dict.ruo.财运);
						res.婚姻.push(dict.ruo.婚姻);
					}
				}

				// ========== 4. 男女命专属婚姻 ==========
				if (gender === "男") {
					if (比肩 + 劫财 >= 2) res.婚姻.push("男命比劫偏旺，易争执克妻，相处宜谦让。");
					if (正财 && 偏财) res.特殊提示.push("男命正偏财混杂，异性缘旺，需防感情纷乱。");
				}
				if (gender === "女") {
					if (伤官 >= 2) res.婚姻.push("女命伤官偏旺，心性清高，婚姻适宜晚婚。");
					if (正官 && 七杀) res.特殊提示.push("女命官杀混杂，姻缘多波折，择偶需谨慎。");
				}

				// ========== 5. 身旺身弱补充 ==========
				if (wangLevel === "身弱") {
					res.事业.push("身弱难担重任，宜守不宜攻，借力贵人稳步发展。");
					res.财运.push("身弱不胜旺财，不宜投机冒险，保守聚财为佳。");
				} else {
					res.事业.push("身旺有能力担当财官，可主动进取，适合开拓发展。");
					res.财运.push("身旺能守能挣，求财门路广，经得起运势起伏。");
				}

				// 去重合并
				const unique = arr => [...new Set(arr)];
				return {
					特殊格局: unique(res.特殊格局),
					组合格局: unique(res.组合格局),
					性格: unique(res.性格).join(""),
					事业: unique(res.事业).join(""),
					财运: unique(res.财运).join(""),
					婚姻: unique(res.婚姻).join(""),
					特殊提示: unique(res.特殊提示).join("")
				};
			}
		},
		watch: {
			sixiang(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.xingge,.shiye,.caiyun,.hunyin{
		background-color: #f3f5f7;
		border-radius: 10px;
		margin-top: 10px;
		padding: 20px;
	}
	.xingge h4,.shiye h4,.caiyun h4,.hunyin h4{
		font-weight: normal;
		font-size: 17px;
		line-height: 30px;
		padding-bottom: 5px;
	}
	.xingge p,.shiye p,.caiyun p,.hunyin p{
		color: #666;
		line-height: 30px;
		text-align: justify;
	}
</style>



// WEBPACK FOOTER //
// src/page/sixiang.vue